import type {DuelBeat} from '../sim';
import {duelTiming} from './duelPresentation';

/** A result is a visible sequence, not a change from a hit frame to a receipt. */
export function terminalTiming(beat:DuelBeat,winner:0|1,reduced=false){
 const exchange=duelTiming(beat),contact=winner===0?exchange.heroContact.at(-1)!:exchange.enemyContact;
 const fallAt=contact+55,landAt=fallAt+(reduced?0:820);
 const celebrateAt=Math.max(landAt, winner===0?exchange.heroRecovery:exchange.enemyContact+240);
 return {contact,fallAt,landAt,celebrateAt,resultAt:celebrateAt+(reduced?450:1000)};
}
export function terminalActor(beat:DuelBeat,winner:0|1,side:0|1,elapsed:number,reduced=false){
 const t=terminalTiming(beat,winner,reduced);
 if(side!==winner&&elapsed>=t.fallAt)return {action:'defeat' as const,actionTime:reduced?1.3:(elapsed-t.fallAt)/1000,advance:0,flash:0};
 if(side===winner&&elapsed>=t.celebrateAt)return {action:'victory' as const,actionTime:reduced?1.4:(elapsed-t.celebrateAt)/1000,advance:0,flash:0};
 return null;
}
import type {AtelierActorFrame,CameraState} from '../../shared';

/** Fit the complete posed silhouette, including ears/tails outside combat hit
 * radii. The actor's conservative skinned bound already exists for framing. */
export function fitTerminalCamera(base:CameraState,frames:AtelierActorFrame[],aspect:number):CameraState {
 const half=(base.orthoHalfH??1)*aspect;
 let lo=-half,hi=half;
 for(const frame of frames){
  const x=frame.model[12],radius=frame.bounds.radius;
  lo=Math.min(lo,x-radius-.12);hi=Math.max(hi,x+radius+.12);
 }
 const x=(lo+hi)/2;
 return {...base,eye:[x,base.eye[1],base.eye[2]],target:[x,base.target[1],base.target[2]],orthoHalfH:Math.max(base.orthoHalfH??1,(hi-lo)/2/aspect)};
}
